import { Configuracao } from './models/configuracao';
import { Selecao } from './models/selecao';

const configs: Configuracao[] = [
  {
    nome: 'GI',
    pastaImagens: 'gi',
    template: 'gi',
    style: 'gi.css',
    esquemaDeCores: {
      domain: ['#016db2', '#f5a505', '#ffeb3b', '#607d8b', '#ff5722', '#957964'],
    },
  },
];

export const globals = {
  apiUrl: localStorage.getItem('urlApi'),
  nomeDaApi: 'EverSolar_API',
  configuracoes: configs,
};

export const opcoesOrientacao: Selecao[] = [
  { id: 'paisagem', descricao: 'Horizontal', imagem: './assets/img/customizadas/estrutura/Paisagem.png' },
  { id: 'retrato', descricao: 'Vertical', imagem: './assets/img/customizadas/estrutura/Retrato.png' },
];

export const opcoesTelhado: Selecao[] = [
  { id: 0, descricao: 'Cerâmica', imagem: './assets/img/customizadas/estrutura/Ceramica.png' },
  { id: 1, descricao: 'Fibrocimento', imagem: './assets/img/customizadas/estrutura/Fibrocimento.png' },
  { id: 2, descricao: 'Galvanizado', imagem: './assets/img/customizadas/estrutura/Galvanizado.png' },
  { id: 3, descricao: 'Zipado', imagem: './assets/img/customizadas/estrutura/Zipado.png' },
];
